import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Why_choose.css";
import Common_section_heading from "../../common_components/common_heading/common_section_heading/Common_section_heading";

const Why_choose = () => {
  const features = [
    {
      id: "01",
      title: "Fast & Easy Recharges",
      desc: "Complete mobile, DTH, & utility recharges in just a few taps.",
    },
    {
      id: "02",
      title: "Secure Payments",
      desc: "Your transactions are protected with industry standard security measures.",
    },
    {
      id: "03",
      title: "All-in-One Platform",
      desc: "Manage recharges, bill payments, rewards, & more from a single app and website.",
    },
    {
      id: "04",
      title: "Exciting Rewards & Offers",
      desc: "Earn points, cashback, and exclusive benefits on every transaction.",
    },
    {
      id: "05",
      title: "24/7 Customer Support",
      desc: "Get help anytime through chat, email, or call.",
    },
    {
      id: "06",
      title: "Trusted by Thousands",
      desc: "Join a growing community of satisfied users who rely on our platform daily.",
    },
  ];

  return (
    <section className="choose_us section_margin">
      <Container>


        <Common_section_heading title="WHY CHOOSE US" subTitle="   Fast, secure, and reliable—everything you need for all your recharges
          and payments."/>

        <Row>
          {features.map((feature) => (
            <Col md={6} sm={6}
              key={feature.id}
              className="mb-4 "
            >
              <div className="section_box ">
                <h4 className="section_heading">{feature.title}</h4>
                <p className="section_text">{feature.desc}</p>
                <span className="section_number">{feature.id}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};
export default Why_choose;
